import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";

import { errorMessage } from "@/api/errors";
import { Button } from "@/components/ui/button";

interface ErrorStateProps {
  error: unknown;
  onRetry?: () => void;
}

export function ErrorState({ error, onRetry }: ErrorStateProps) {
  const { t, i18n } = useTranslation();
  return (
    <div role="alert" className="flex flex-col items-center gap-2 px-4 py-12 text-center">
      <AlertTriangle className="text-destructive size-8" aria-hidden />
      <p className="font-medium">{t("common.loadError")}</p>
      <p className="text-muted-foreground text-sm">
        {errorMessage(
          error,
          (key, values) => t(key, values),
          key => i18n.exists(key),
        )}
      </p>
      {onRetry ? (
        <Button variant="outline" size="sm" onClick={onRetry}>
          {t("common.retry")}
        </Button>
      ) : null}
    </div>
  );
}
